import { useSelector } from "react-redux";

const Text = ({ children, color = null, size = 14 }) => {

    const { textPrimaryColor } = useSelector((store: any) => (store.ui));

    return (
        <span style={{ color: color || textPrimaryColor, fontSize: (size + 'px') }}>{children}</span>
    )
}


export default Text;
